/**
 * @feature landing-page
 * @owner das-finsuite-application-dev
 * @description FinSuite fiscal-quarter month boundaries, shared across landing-page widgets
 * (MEC Work Day widget, Quarter Progress card).
 *
 * FinSuite tracks calendar quarters, but each quarter's reporting period extends through the
 * FOLLOWING month's "extended close" (confirmed by Nik / FGBS):
 *
 *   Quarter | Calendar months | Starts | Extended close completes (period end)
 *   --------|-----------------|--------|--------------------------------------
 *   Q1      | Jan - Mar       | Jan    | Apr
 *   Q2      | Apr - Jun       | Apr    | Jul
 *   Q3      | Jul - Sep       | Jul    | Oct
 *   Q4      | Oct - Dec       | Oct    | Jan (following year)
 *
 * The two arrays are index-paired by quarter: QUARTER_START_MONTHS[i] -> QUARTER_END_MONTHS[i]
 * is the start month and close (period-end) month for quarter (i + 1).
 * Months are 1-indexed (Jan = 1 ... Dec = 12).
 *
 * To change the fiscal model later, update ONLY these two arrays.
 */

/** Month each fiscal quarter begins (1-indexed): Q1 Jan, Q2 Apr, Q3 Jul, Q4 Oct. */
export const QUARTER_START_MONTHS = [1, 4, 7, 10] as const;

/**
 * Month each fiscal quarter's extended close completes (1-indexed): Q1 Apr, Q2 Jul, Q3 Oct, Q4 Jan.
 * As a set this is the list of "close months" {Jan, Apr, Jul, Oct} that MecWorkDayWidget uses to
 * decide when to show all MEC work days (vs. capping non-close months at 10).
 */
export const QUARTER_END_MONTHS = [4, 7, 10, 1] as const;
